import Vue from 'vue';
import moment from 'moment';
import MemberUtils from '../memberUtils';
import { camelizeKeys, underscoreKeys } from '../lib/functions';

// deprecated. Use ./member.js
export default {
  state: {
    memberId: null,
    cognitoUsername: null,
    birthDate: null,
    emailAddress: null,
    gender: null,
    height: null,
    weight: null,
    firstName: null,
    lastName: null,
    memberType: null,
    accessLevel: 0,
    showFolloweeRealName: null,
    garminOauthToken: null,
    suuntoAuthToken: null,
    suuntoV2OauthToken: null,
    polarOauthToken: null,
    teams: [],
    prefersMetric: null,
  },
  getters: {
    user: state => state,
    memberId: state => state.memberId,
    cognitoId: state => state.cognitoUsername,
    isCoach: state => state.memberType === 'Coach',
  },
  mutations: {
    setMemberId(state, payload) {
      state.memberId = payload;
    },
    setCognitoUsername(state, payload) {
      state.cognitoUsername = payload;
    },
    setBirthDate(state, payload) {
      state.birthDate = payload;
    },
    setEmailAddress(state, payload) {
      state.emailAddress = payload;
    },
    setGender(state, payload) {
      state.gender = payload;
    },
    setHeight(state, payload) {
      state.height = payload;
    },
    setWeight(state, payload) {
      state.weight = payload;
    },
    setFirstname(state, payload) {
      state.firstName = payload;
    },
    setLastname(state, payload) {
      state.lastName = payload;
    },
    setMemberType(state, payload) {
      state.memberType = payload;
    },
    setAccessLevel(state, payload) {
      state.accessLevel = payload;
    },
    setShowFolloweeRealName(state, payload) {
      state.showFolloweeRealName = payload;
    },
    setGarminOauthToken(state, payload) {
      state.garminOauthToken = payload;
    },
    setSuuntoAuthToken(state, payload) {
      state.suuntoAuthToken = payload;
    },
    setSuuntoV2OauthToken(state, payload) {
      state.suuntoV2OauthToken = payload;
    },
    setPolarOauthToken(state, payload) {
      state.polarOauthToken = payload;
    },
    setPrefersMetric(state, payload) {
      state.prefersMetric = payload;
    },
    setUserProperties(state, payload) {
      Object.keys(payload).forEach((key) => {
        if (key in state) {
          state[key] = payload[key];
        }
      });

      if (payload.memberId) {
        this.$container.logger.setUserContext({
          email: payload.emailAddress,
          member_id: payload.memberId,
          name: `${payload.firstName} ${payload.lastName}`,
          member_type: payload.memberType,
          cognito_user_id: payload.cognitoUsername,
        });
      }
    },
    clearUser(state) {
      Object.keys(state).forEach((key) => {
        state[key] = null;
      });

      this.$container.logger.setUserContext();
    },
    moveForwardInTime(state, payload) {
      state.accessTokens.credentials_expire = moment(
        state.accessTokens.credentials_expire,
      ).subtract(payload, 'minutes').toISOString();
      state.accessTokens.expires = moment(state.accessTokens.expires).subtract(payload, 'minutes');
    },
    setTokenTimeout(state, payload) {
      state.accessTokens.expires = payload;
    },
    updateUser(state, user) {
      Object.entries(Object.assign(state, user)).forEach(([k, v]) => {
        Vue.set(state, k, v);
      });
    },
  },
  actions: {
    setUser(context, payload) {
      context.commit('setUser', payload);
    },
    setMemberId(context, payload) {
      context.commit('setMemberId', payload);
    },
    setCognitoUsername(context, payload) {
      context.commit('setCognitoUsername', payload);
    },
    setBirthDate(context, payload) {
      context.commit('setBirthDate', payload);
    },
    setEmailAddress(context, payload) {
      context.commit('setEmailAddress', payload);
    },
    setGender(context, payload) {
      context.commit('setGender', payload);
    },
    setHeight(context, payload) {
      context.commit('setHeight', payload);
    },
    setWeight(context, payload) {
      context.commit('setWeight', payload);
    },
    setFirstname(context, payload) {
      context.commit('setFirstname', payload);
    },
    setLastname(context, payload) {
      context.commit('setLastname', payload);
    },
    setMemberType(context, payload) {
      context.commit('setMemberType', payload);
    },
    setAccessLevel(context, payload) {
      context.commit('setAccessLevel', payload);
    },
    showFolloweeRealName(context, payload) {
      context.commit('showFolloweeRealName', payload);
    },
    setGarminOauthToken(context, payload) {
      context.commit('setGarminOauthToken', payload);
    },
    setSuuntoAuthToken(context, payload) {
      context.commit('setSuuntoAuthToken', payload);
    },
    setSuuntoV2OauthToken(context, payload) {
      context.commit('setSuuntoV2OauthToken', payload);
    },
    setPolarOauthToken(context, payload) {
      context.commit('setPolarOauthToken', payload);
    },
    setUserProperties(context, payload) {
      context.commit('setUserProperties', payload);
    },
    setPrefersMetric(context, payload) {
      context.commit('setPrefersMetric', payload);
    },
    async loadMemberByAwsCognitoSub(context, payload) {
      // payload is the aws cognito sub
      const member = await this.$container.dao.getMemberByAwsCognitoSub(payload);
      const userProperties = MemberUtils.mapMember(member);
      this.dispatch('setUserProperties', userProperties);
    },
    mapAndSetUserProperties(context, payload) {
      const userProperties = MemberUtils.mapMember(payload);
      this.dispatch('setUserProperties', userProperties);
    },
    async updateMember(context, payload) {
      // payload is a member
      await this.$container.dao.updateMember(payload);
      await this.dispatch('loadMember', payload.memberId);
    },
    setMember(context, payload) {
      this.dispatch('setUserProperties', MemberUtils.mapMember(payload));
    },
    addMember(context, payload) {
      return this.$container.dao.addMember(payload);
    },
    clearUser(context) {
      context.commit('clearUser');
    },
    moveForwardInTime(context, payload) {
      context.commit('moveForwardInTime', payload);
    },
    setTokenTimeout(context, payload) {
      context.commit('setTokenTimeout', payload);
    },
    updateUser(context, user) {
      context.commit('updateUser', user);
    },
    async initiateForgotPassword(context, email) {
      let result = null;
      try {
        result = await this.$container.apiHttpClient.post('/auth/forgot-password', { email });
      } catch (e) {
        this.$container.logger.capture(e);
        throw e;
      }

      return result.status === 200;
    },
    async confirmPasswordReset(context, { email, code, password }) {
      const data = { email, code, password };
      const result = await this.$container.apiHttpClient.post('/auth/confirm-password-reset', data);

      return result.data;
    },
    async changePassword(context, { oldPassword, newPassword }) {
      let result = null;
      try {
        result = await this.$container.apiHttpClient.post(
          '/auth/change-password',
          {
            tokens: underscoreKeys(context.getters.tokens),
            old_password: oldPassword,
            new_password: newPassword,
          },
        );
      } catch (e) {
        this.$container.logger.capture(e);
        throw e;
      }

      return result.status === 200;
    },
  },
};
